import { Suspense } from 'react'
import { RoundMarquee } from './RoundMarquee'
import { Helper } from '../../../../classes/helper'
import { MarqueeFabric } from './parts/MarqueeFabric'
import { MarqueeRail } from './parts/MarqueeRail'
import { useMarquee } from '../../../../hooks/state/useMarquee'
interface Props {
  marqueeWidth: number
  marqueePosition: [number, number, number]
}

export const Marquee = ({
  marqueeWidth,
  marqueePosition,
}: Props): JSX.Element => {
  const { marqueeTyp, maqrueeAttributes, turningBox } = useMarquee()
  const casing = {
    radius: 0.05,
    width: marqueeWidth,
  }
  const railBottom = {
    height: 0.02,
  }

  const topMarquee = turningBox
  const rotateMarqueeBox = topMarquee ? Helper.convertAngleToRadiant(-180) : 0

  return (
    <Suspense fallback={null}>
      <group
        castShadow
        position={marqueePosition}
        rotation={[
          0,
          Helper.convertAngleToRadiant(90),
          Helper.convertAngleToRadiant(90),
        ]}
      >
        <RoundMarquee
          marqueeWidth={marqueeWidth}
          position={[
            maqrueeAttributes.height +
              (topMarquee && marqueeTyp.hasUnderRoof
                ? -railBottom.height + 0.035
                : marqueeTyp.hasUnderRoof
                ? railBottom.height
                : railBottom.height),
            0,
            0,
          ]}
          rotation={[0, 0, rotateMarqueeBox]}
        />
        <MarqueeFabric
          fabricWidth={marqueeWidth}
          position={[
            casing.radius +
              (topMarquee
                ? marqueeTyp.hasUnderRoof
                  ? -maqrueeAttributes.height
                  : -maqrueeAttributes.height
                : maqrueeAttributes.height),
            0,
            -casing.radius,
          ]}
          rotation={[0, 0, rotateMarqueeBox]}
        />

        <MarqueeRail
          marqueeWidth={marqueeWidth}
          rotation={[0, 0, rotateMarqueeBox]}
        />
      </group>
    </Suspense>
  )
}
